<template>

<div 
    class="item" 
    :class="{
        'is-condensed': isCondensed,
        'is-selected': isSelected,
        'is-sticky': isSticky
    }"
    :style="style"
    v-height-watch="{ enabled: isWatchingHeight, onChange: onHeightChange }"
>

    <div 
        class="item-content"
        :style="{gridTemplateColumns: gridFinal}"
    >

        <component 
            :is="fieldComponent(field)" 
            :item="item" 
            :field="field" 
            :filter="filter" 
            :key="field.id" 
            :is-condensed="isCondensed"
            v-for="field in fields" 
        />

        <core-list-cell-actions 
            :item="item" 
            :filter="filter" 
            :can="can" 
            :condensed="isCondensed" 
            v-if="hasActions" 
            class="item-actions"
        />

    </div>

    <app-view-list-item-nested :item="item" :fields="fields" :filter="filter" :is-sticky="isSticky" :grid="grid" />
    <app-view-list-item-contained :item="item" :fields="fields" :filter="filter" :is-sticky="isSticky" :grid="grid" />

    <app-view-list-demoted v-if="$isMobile && hasDemoted && !isSticky && !isCondensed">

        <component 
            :is="fieldComponent(field)" 
            :item="item" 
            :field="field" 
            :filter="filter" 
            :key="field.id" 
            :is-condensed="isCondensed"
            :is-demoted="true"
            v-for="field in demoted" 
        />

    </app-view-list-demoted>

    <slot></slot>

</div>

</template>

<script>

export default {

	props: ['item', 'fields', 'stickyHeight', 'demoted', 'filter', 'grid', 'can', 'isCondensed', 'isSticky'],

    computed: {

        style: function() {

            var style = {}

            if (this.stickyHeight) {

                style.height = this.stickyHeight + 'px'

            }

            return style 

        },

        isWatchingHeight: function() {

            return !this.isSticky && !this.isCondensed

        },

        hasDemoted: function() {

            return (this.demoted) ? this.demoted.length : false

        },

        isSelected: function() {

			return this.$store.getters['service/select'](this.item.id)

		},

        hasActions: function() {

            return this.$route.meta.hasActions && !this.isSticky

        },

        gridFinal: function() {

            if (this.isSticky) return this.grid

            return this.grid + ' auto'

        }

    },

    methods: {

        onHeightChange: function(e) {

            this.$emit('height', e.height)

        },

        fieldComponent: function(field) {

            var component = ['app', 'view', 'list', 'field']

            component.push(field.type.replace('.', '_'))

            return component.join('-')

        }

    }

}

</script>

<style scoped>

.item {
	border-bottom: 1px solid #eee;
    position: relative;
}

.item:not(.is-sticky) {
    display: inline-grid;
    min-width: 100%;
}

.item.is-condensed,
.item:last-child {
	border-bottom: 0px;
}

.item.is-selected {
	background-color: #d4f2ff;
}

.is-desktop .item:not(.is-selected):hover {
	background-color: #e9f3f7;
}

.is-desktop .item:not(.is-selected).is-condensed:hover {
	background-color: rgba(0, 0, 0, 0.1);
}

.is-desktop .item.is-selected:hover {
	background-color: #c6e5f3;
}

.item-content {
    display: grid;
    min-height: 58px;
    grid-gap: 10px;
    padding: 0px 5px;
    align-items: flex-start;
}

.is-mobile .item-content {
    grid-gap: 5px;
    align-items: flex-start;
    height: auto;
}

.is-sticky .item-content {
    padding: 0px 10px;
}

.is-mobile .is-sticky .item-content {
    padding: 0px 5px;
}

.item.is-condensed .item-content {
    min-height: 28px;
}

.item:last-child .item-content {
	border-bottom: 0px;
}

.item-actions {
    padding: 5px 0px;
    height: 58px;
}

</style>